import Icon from '@components/v2/ui/Icon/Icon';
import StatusChip from '@components/v2/ui/StatusChip/StatusChip';
import { Users } from 'lucide-react';
import { CUSTOMER_STATUS_CHIP_CONFIG } from '../../../../../customer/customerStatus/customerStatusChip.constants';
import { CustomerSearchResultItem } from '../../../../globalSearch.types';
import HighlightedText from '../../../HighlightedText';
import ResultRowBase from '../../ResultRowBase';
import { ResultRowRendererProps } from '../../resultRow.types';
import { formatCityState, joinResultParts } from '../../resultRow.utils';

function CustomerRow({
  item,
  query,
  isActive,
  isDisabled,
  domId,
  onSelect,
}: ResultRowRendererProps<CustomerSearchResultItem>) {
  const statusConfig = CUSTOMER_STATUS_CHIP_CONFIG[item.status];
  const subtitle = joinResultParts([
    item.subtitle,
    formatCityState({ city: item.city, state: item.state }),
  ]);

  return (
    <ResultRowBase
      testId={`global-search-item-${item.entityType}-${item.id}`}
      isActive={isActive}
      isDisabled={isDisabled}
      domId={domId}
      onClick={onSelect}
      leading={<Icon icon={Users} size="md" />}
      title={<HighlightedText text={item.title} query={query} />}
      subtitle={subtitle ? <HighlightedText text={subtitle} query={query} /> : undefined}
      line1Trailing={statusConfig && <StatusChip {...statusConfig} />}
    />
  );
}

export default CustomerRow;
